import { RootState } from '../../model/model'

export const selectInDisplayContent = (state: RootState) =>
	state.displayContent?.type ? state.displayContent : undefined

export const selectVideoStatus = (state: RootState) => state.displayContent?.videoStatus
